import { ComponentRoute } from '@/classes'

const DebtorAgingReportRoutes = {
  DebtorAgingReportView: new ComponentRoute('/aragingreports', 'DebtorAgingReportView')
}

export default DebtorAgingReportRoutes
